export type SurveyStepType = {
  number: number;
  subtitle: string;
  submitLabel?: string;
};

export type SurveyCommentStepType = SurveyStepType & {
  text?: string;
  submitLabel?: string;
};

export type SurveyFinishStepType = {
  title?: string;
  subtitle?: string;
};

export enum SurveyType {
  nps = 'nps',
  psat = 'psat',
}
